// Small formatting + presentation helpers

export function fmtTime(t) {
  // "19:30" -> "7:30 PM"
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const period = h >= 12 ? "PM" : "AM";
  const hh = h % 12 === 0 ? 12 : h % 12;
  return `${hh}:${String(m).padStart(2, "0")} ${period}`;
}

export function fmtTimeShort(dtIso) {
  if (!dtIso) return "";
  const d = new Date(dtIso);
  return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function fmtDate(dateStr) {
  // "2026-05-08" -> "Fri, May 8"
  if (!dateStr) return "";
  const d = new Date(`${dateStr}T00:00:00`);
  return `${WEEKDAYS[d.getDay()]}, ${MONTHS[d.getMonth()]} ${d.getDate()}`;
}

export function fmtDateLong(dtIso) {
  if (!dtIso) return "";
  const d = new Date(dtIso);
  return `${WEEKDAYS[d.getDay()]}, ${MONTHS[d.getMonth()]} ${d.getDate()}`;
}

export function dayLabel(day) {
  return `Day ${day}`;
}

// "2026-12-10" -> "THU DEC 10" (upper, comma-free) for attendee day headers.
export function fmtDateUpper(dateStr) {
  if (!dateStr) return "";
  const d = new Date(`${dateStr}T00:00:00`);
  return `${WEEKDAYS[d.getDay()]} ${MONTHS[d.getMonth()]} ${d.getDate()}`.toUpperCase();
}

/**
 * SHARED attendee-facing day label. Personalized "Day N" is computed by the
 * backend (personalized_day_number) and delivered as `attendee_day`; this helper
 * only presents it. When attendeeDay is null/undefined (participation start
 * unavailable, or an outside-window exception) it safely falls back to the
 * calendar date — never "Day 0" or a negative number.
 * attendeeDayLabel(1, "2026-12-10") -> "DAY 1 · THU DEC 10"
 * attendeeDayLabel(null, "2026-12-10") -> "THU DEC 10"
 */
export function attendeeDayLabel(attendeeDay, dateStr) {
  const datePart = fmtDateUpper(dateStr);
  if (attendeeDay == null) return datePart;
  return `DAY ${attendeeDay} · ${datePart}`;
}

// Short form for compact day tabs: "Day 1" or "" when unavailable.
export function attendeeDayShort(attendeeDay) {
  return attendeeDay == null ? "" : `Day ${attendeeDay}`;
}

export function initials(name) {
  if (!name) return "";
  return name
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

// Category -> lucide icon name mapping handled in components; return accent color
export function categoryAccent(category) {
  switch (category) {
    case "recognition":
    case "gala":
      return "gold";
    case "wellness":
    case "leisure":
      return "mint";
    case "meeting":
      return "lavender";
    default:
      return "teal";
  }
}
